/* Fiche « Avera™ Aria Ring » : copie conforme de la fiche Amoria « ARIA RING » (06/10/2026).
   Le contenu vit dans le shadow DOM de <aar-page> (sections/aar-page.liquid). Ce fichier reprend les scripts de la
   source, portés sur le shadow root : galerie (thème Shrine PRO), bandeaux à compte à rebours, offre 1 ou 2 bagues +
   personnalisation (couleur, taille, pierres) et ajout au panier, bloc « Limited offer », carrousel vidéo.
   Seule différence voulue : l'ajout au panier ouvre le panier latéral d'Avera (comme les autres copies). */
(function () {
  'use strict';
  var host = document.querySelector('aar-page');
  if (!host || !host.shadowRoot) return;
  var root = host.shadowRoot;
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };
  var htmlEl = $('aar-html');

  /* ---------- Hauteur du header : celui d'Avera remplace celui de Amoria (--header-height de leur thème) ---------- */
  function syncHeader() {
    var header = document.querySelector('.shopify-section-group-header-group header, sticky-header, #shopify-section-header');
    var h = 0;
    if (header) {
      var sec = header.closest('.shopify-section') || header;
      var cs = getComputedStyle(sec);
      if (cs.position === 'sticky' || cs.position === 'fixed') h = Math.round(header.getBoundingClientRect().height);
    }
    htmlEl.style.setProperty('--header-height', h + 'px');
  }
  syncHeader();
  window.addEventListener('resize', syncHeader);

  function debounce(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }

  /* ---------- Galerie produit (slider-component + media-gallery de leur thème) ---------- */
  var gallery = $('aar-media-gallery');
  if (gallery) {
    var viewer = $('[id^="GalleryViewer"]', gallery), vList = $('[id^="Slider-Gallery"]', gallery);
    var thumbs = $('[id^="GalleryThumbnails"]', gallery), tList = thumbs && $('[id^="Slider-Thumbnails"]', thumbs);
    var slides = $$('.product__media-item', vList);
    var setThumb = function (mediaId) {
      if (!tList) return;
      var item = $('[data-target="' + mediaId + '"]', tList);
      $$('button', tList).forEach(function (b) { b.removeAttribute('aria-current'); });
      if (!item) return;
      $('button', item).setAttribute('aria-current', true);
      var l = tList.scrollLeft, w = tList.clientWidth, x = item.offsetLeft - tList.firstElementChild.offsetLeft;
      if (x < l || x + item.clientWidth > l + w) tList.scrollTo({ left: x });
    };
    var setActive = function (li) {
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      li.classList.add('is-active');
    };
    $$('[data-target]', tList || gallery).forEach(function (item) {
      $('button', item).addEventListener('click', function () {
        var li = $('[data-media-id="' + item.dataset.target + '"]', vList);
        if (!li) return;
        setActive(li);
        setTimeout(function () { vList.scrollTo({ left: li.offsetLeft - vList.firstElementChild.offsetLeft }); });
        setThumb(item.dataset.target);
      });
    });
    var onScroll = debounce(function () {
      if (!slides.length) return;
      var step = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : vList.clientWidth;
      var i = Math.max(0, Math.min(slides.length - 1, Math.round(vList.scrollLeft / (step || 1))));
      if (!slides[i].classList.contains('is-active')) { setActive(slides[i]); setThumb(slides[i].dataset.mediaId); }
    }, 120);
    vList.addEventListener('scroll', onScroll, { passive: true });
    // flèches des vignettes (data-step) et du visualiseur
    [[thumbs, tList], [viewer, vList]].forEach(function (pair) {
      var comp = pair[0], list = pair[1];
      if (!comp || !list) return;
      var prev = $('button[name="previous"]', comp), next = $('button[name="next"]', comp);
      if (!prev || !next) return;
      var items = function () { return $$('.slider__slide', list).filter(function (x) { return x.clientWidth > 0; }); };
      var update = function () {
        var max = list.scrollWidth - list.clientWidth;
        if (list.scrollLeft <= 1) prev.setAttribute('disabled', 'disabled'); else prev.removeAttribute('disabled');
        if (list.scrollLeft >= max - 1) next.setAttribute('disabled', 'disabled'); else next.removeAttribute('disabled');
      };
      var go = function (dir, btn) {
        var it = items(); if (it.length < 2) return;
        var off = it[1].offsetLeft - it[0].offsetLeft;
        var step = parseInt(btn.dataset.step, 10) || 1;
        list.scrollTo({ left: list.scrollLeft + dir * step * off, behavior: 'smooth' });
      };
      prev.addEventListener('click', function (e) { e.preventDefault(); go(-1, prev); });
      next.addEventListener('click', function (e) { e.preventDefault(); go(1, next); });
      list.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(list);
      update();
    });
  }


  /* ---------- Bandeaux « LIMITED OFFER » à compte à rebours (4 h, mémorisé comme chez eux) ---------- */
  var DUR = 4 * 3600 * 1000, KEY = 'averaAriaUrgEnd';
  function two(n) { return (n < 10 ? '0' : '') + n; }
  function getEnd() {
    var v = 0;
    try { v = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
    if (!v || (v - Date.now()) <= 0 || (v - Date.now()) > DUR) { v = Date.now() + DUR; try { localStorage.setItem(KEY, v); } catch (e) {} }
    return v;
  }
  // barre d'annonce d'Avera (hors shadow DOM) : même compte à rebours
  Array.prototype.slice.call(document.querySelectorAll('.aar-ann-timer')).forEach(function (tm) {
    var u = {}; ['d', 'h', 'm', 's'].forEach(function (k) { u[k] = tm.querySelector('[data-u="' + k + '"]'); });
    var end = getEnd();
    function tick() {
      var r = end - Date.now();
      if (r <= 0) { end = Date.now() + DUR; try { localStorage.setItem(KEY, end); } catch (e) {} r = DUR; }
      u.d.textContent = two(Math.floor(r / 86400000)); u.h.textContent = two(Math.floor(r % 86400000 / 3600000));
      u.m.textContent = two(Math.floor(r % 3600000 / 60000)); u.s.textContent = two(Math.floor(r % 60000 / 1000));
    }
    tick(); setInterval(tick, 1000);
  });
  $$('.avera-annc').forEach(function (bar) {
    var d = $('.avera-annc__d', bar), h = $('.avera-annc__h', bar), m = $('.avera-annc__m', bar), s = $('.avera-annc__s', bar);
    var end = getEnd();
    function tick() {
      var r = end - Date.now();
      if (r <= 0) { end = Date.now() + DUR; try { localStorage.setItem(KEY, end); } catch (e) {} r = DUR; }
      if (d) d.textContent = two(Math.floor(r / 86400000)); if (h) h.textContent = two(Math.floor(r % 86400000 / 3600000));
      if (m) m.textContent = two(Math.floor(r % 3600000 / 60000)); if (s) s.textContent = two(Math.floor(r % 60000 / 1000));
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Bloc « LIMITED OFFER » sous le bouton : minuteur, stock aléatoire de session, ajustement de la police ---------- */
  $$('.avera-urg').forEach(function (urg) {
    var t = $('.avera-urg__timer', urg), f = $('.avera-urg__fill', urg), s = $('.avera-urg__stock', urg);
    var end = getEnd();
    function tick() {
      var r = end - Date.now();
      if (r <= 0) { end = Date.now() + DUR; try { localStorage.setItem(KEY, end); } catch (e) {} r = DUR; }
      if (t) t.textContent = two(Math.floor(r / 3600000)) + ':' + two(Math.floor(r % 3600000 / 60000)) + ':' + two(Math.floor(r % 60000 / 1000));
    }
    tick(); setInterval(tick, 1000);
    var st = 0;
    try { st = parseInt(sessionStorage.getItem('averaAriaUrgStock') || '0', 10); } catch (e) {}
    if (!st) { st = 3 + Math.floor(Math.random() * 6); try { sessionStorage.setItem('averaAriaUrgStock', st); } catch (e) {} }
    if (s) s.textContent = st;
    if (f) { f.style.width = '0'; setTimeout(function () { f.style.width = (100 - st) + '%'; }, 60); }
    function fit(row) {
      var flex = $('.avera-urg__sub, .avera-urg__ship', row); if (!flex) return;
      var fs = 11, g = 0; row.style.fontSize = fs + 'px';
      while (flex.scrollWidth > flex.clientWidth + 1 && fs > 8 && g < 16) { fs -= 0.5; row.style.fontSize = fs + 'px'; g++; }
    }
    function fitAll() { $$('.avera-urg__row', urg).forEach(fit); }
    requestAnimationFrame(fitAll);
    window.addEventListener('resize', fitAll);
  });

  /* ---------- Offre + personnalisation + ajout au panier (leur script, mêmes libellés et propriétés de ligne) ---------- */
  var perso = $('.avera-perso');
  if (perso) {
    var paidId = perso.dataset.paidId, freeId = perso.dataset.freeId;
    var btn = $('.avera-add', perso);
    var err = $('.avera-perso__err', perso);
    var T = {
      add1: 'Add my ring', add2: 'Add my rings', adding: 'Adding…',
      errPrefix: 'Please complete: ', errColor: 'the colour', errSize: 'the size',
      errLeft: 'the left stone', errRight: 'the right stone', ringWord: 'ring',
      errGeneric: 'An error occurred: ', errRetry: '. Please try again.',
      pColor: 'Colour', pSize: 'Size', pLeft: 'Left stone', pRight: 'Right stone', pGift: 'Second ring free'
    };
    var offer = function () { var s = $('.avera-offer.is-selected', perso); return s ? s.getAttribute('data-offer') : '1'; };
    var isDuo = function () { return offer() === '2'; };
    var val = function (n) {
      var ch = $('[name="' + n + '"]:checked', perso); if (ch) return ch.value;
      var el = $('select[name="' + n + '"], input[name="' + n + '"]', perso); return el ? el.value : '';
    };
    var refresh = function () {
      $('[data-ring="2"]', perso).style.display = isDuo() ? 'block' : 'none';
      var price = btn.getAttribute('data-price') || '';
      btn.textContent = (isDuo() ? T.add2 : T.add1) + (price ? ' — ' + price : '');
    };
    $$('.avera-offer', perso).forEach(function (card) {
      card.addEventListener('click', function () {
        $$('.avera-offer', perso).forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected'); refresh();
      });
    });
    perso.addEventListener('change', function (e) {
      if (e.target.name && e.target.name.indexOf('-color') > -1) {
        var box = e.target.closest('.avera-colors');
        $$('.avera-csw', box).forEach(function (l) { l.classList.remove('is-selected'); });
        e.target.closest('.avera-csw').classList.add('is-selected');
        var nm = $('.avera-cname', box); if (nm) nm.textContent = e.target.value;
      }
      if (e.target.classList && e.target.classList.contains('avera-select')) e.target.classList.remove('avera-invalid');
    });
    $$('.avera-dd', perso).forEach(function (dd) {
      var btnEl = $('.avera-dd__btn', dd), cur = $('.avera-dd__cur', dd);
      var input = $('input[name="' + dd.getAttribute('data-name') + '"]', perso);
      btnEl.addEventListener('click', function (e) {
        e.stopPropagation();
        var wasOpen = dd.classList.contains('open');
        $$('.avera-dd.open', perso).forEach(function (o) { o.classList.remove('open'); });
        if (!wasOpen) dd.classList.add('open');
      });
      $$('.avera-dd__opt', dd).forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          e.stopPropagation();
          input.value = opt.getAttribute('data-value');
          cur.innerHTML = '<img src="' + opt.getAttribute('data-img') + '" alt=""><span>' + opt.getAttribute('data-mois') + '</span>';
          dd.classList.remove('open'); dd.classList.remove('is-invalid');
        });
      });
    });
    document.addEventListener('click', function () { $$('.avera-dd.open', perso).forEach(function (o) { o.classList.remove('open'); }); });

    var modal = $('.avera-modal', perso);
    var closeModal = function () { modal.classList.remove('open'); modal.setAttribute('aria-hidden', 'true'); };
    $$('.avera-guide', perso).forEach(function (g) {
      g.addEventListener('click', function () { modal.classList.add('open'); modal.setAttribute('aria-hidden', 'false'); });
    });
    $('.avera-modal__x', modal).addEventListener('click', closeModal);
    $('.avera-modal__bg', modal).addEventListener('click', closeModal);

    var markInvalid = function (name) {
      var sel = $('select[name="' + name + '"]', perso);
      if (sel) { sel.classList.add('avera-invalid'); return; }
      var dd = $('.avera-dd[data-name="' + name + '"]', perso);
      if (dd) dd.classList.add('is-invalid');
    };
    var validate = function () {
      var groups = ['1']; if (isDuo()) groups.push('2');
      var missing = [];
      $$('.avera-invalid', perso).forEach(function (x) { x.classList.remove('avera-invalid'); });
      $$('.avera-dd.is-invalid', perso).forEach(function (x) { x.classList.remove('is-invalid'); });
      groups.forEach(function (g) {
        var suffix = isDuo() ? ' (' + T.ringWord + ' ' + g + ')' : '';
        [['color', T.errColor], ['size', T.errSize], ['left', T.errLeft], ['right', T.errRight]].forEach(function (f) {
          var name = 'avera-' + g + '-' + f[0];
          if (!val(name)) { missing.push(f[1] + suffix); markInvalid(name); }
        });
      });
      return missing;
    };
    var props = function (g) {
      var p = {};
      p[T.pColor] = val('avera-' + g + '-color'); p[T.pSize] = val('avera-' + g + '-size');
      p[T.pLeft] = val('avera-' + g + '-left'); p[T.pRight] = val('avera-' + g + '-right');
      return p;
    };
    btn.addEventListener('click', function () {
      var missing = validate();
      if (missing.length) { err.textContent = T.errPrefix + missing.join(', ') + '.'; err.style.display = 'block'; err.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      err.style.display = 'none';
      var items = [{ id: Number(paidId), quantity: 1, properties: props('1') }];
      if (isDuo()) { var p2 = props('2'); p2['🎁'] = T.pGift; items.push({ id: Number(freeId), quantity: 1, properties: p2 }); }
      btn.disabled = true; var old = btn.textContent; btn.textContent = T.adding;
      // panier latéral d'Avera (FullStack) : POST avec la section du tiroir, puis « cart:updated » et ouverture
      var drawer = document.querySelector('cart-drawer');
      var icon = document.querySelector('cart-icon');
      var before = icon && icon.getCurrentItemCount ? icon.getCurrentItemCount() : NaN;
      var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || r + 'cart/add';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: drawer ? drawer.dataset.sectionId : '' })
      })
        .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok || (res.d.status && Number(res.d.status) >= 400)) throw new Error(res.d && res.d.description ? res.d.description : 'Error');
          btn.disabled = false; refresh();
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { resource: {}, data: {
            itemCount: isNaN(before) ? undefined : before + items.length, source: 'product-form', variantId: String(paidId), sections: res.d.sections } } }));
          if (drawer && drawer.open && !(drawer.isOpen && drawer.isOpen())) drawer.open();
          else if (!drawer) window.location.href = r + 'cart';
        })
        .catch(function (e) { btn.disabled = false; btn.textContent = old; err.textContent = T.errGeneric + e.message + T.errRetry; err.style.display = 'block'; });
    });
    refresh();
  }

  /* ---------- « They wear Avera » : carrousel vidéo (carte active au centre, lecture muette de la carte active) ---------- */
  $$('[id^="avera-vid-"]').forEach(function (vr) {
    var cards = $$('.avera-vid__card', vr);
    var n = cards.length; if (!n) return;
    var active = Math.floor(n / 2);
    function layout() {
      var prev = (active - 1 + n) % n, next = (active + 1) % n;
      cards.forEach(function (c, i) {
        c.classList.remove('is-active', 'is-prev', 'is-next');
        if (i === active) c.classList.add('is-active');
        else if (i === prev && n > 1) c.classList.add('is-prev');
        else if (i === next && n > 2) c.classList.add('is-next');
        var v = $('video', c); if (v) { if (i === active) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } }
      });
    }
    function go(d) { active = (active + d + n) % n; layout(); }
    $('.avera-vid__nav--next', vr).addEventListener('click', function () { go(1); });
    $('.avera-vid__nav--prev', vr).addEventListener('click', function () { go(-1); });
    cards.forEach(function (c, i) { c.addEventListener('click', function () { if (i !== active) { active = i; layout(); } }); });
    layout();
  });
})();
